<template>
  <div class="t-tags" :class="{ _white: white, 't-container': isContainer }">
    <transition name="fade">
      <div v-if="scrollTags > 0 && isArrow" class="t-tags__arrow _left" @click="scrollToLeft">
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.81304 5.49489L0.902746 0L0 1.01022L4.45892 6L0 10.9898L0.902746 12L5.81304 6.50511C6.06232 6.22615 6.06232 5.77385 5.81304 5.49489Z"
            fill="#929292"
          />
        </svg>
      </div>
    </transition>

    <div class="t-tags__container" ref="tags" @scroll="changeScroll">
      <template v-if="disableFilter">
        <div v-for="(item, index) in tags" class="t-tags-block__item" :key="'tags-item-' + index">
          <span class="t-tags__name">{{ item.name ? item.name : item }}</span>
        </div>
      </template>
      <template v-else>
        <div
          v-if="isAll"
          class="t-tags__item"
          :class="{ _active: checked.filter(item => item !== undefined).length === 0 }"
          @click="deleteTags()"
        >
          <span class="t-tags__name">{{ $root.staticText.tagsAll }}</span>
        </div>
        <div
          v-for="(item, index) in tags"
          class="t-tags__item"
          :key="'tags-item-' + index"
          :class="{ _active: checked[index] === item.id }"
          @click="addTags(index, item.id)"
        >
          <span class="t-tags__name">{{ item.name }}</span>
          <svg
            class="t-tags__delete"
            @click.prevent.stop="deleteTags(index, item.id)"
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.8 4L7.6 1.2C7.82091 0.979086 7.82091 0.620914 7.6 0.4C7.37909 0.179086 7.02091 0.179086 6.8 0.4L4 3.2L1.2 0.4C0.979086 0.179086 0.620914 0.179086 0.4 0.4C0.179086 0.620914 0.179086 0.979086 0.4 1.2L3.2 4L0.4 6.8C0.179086 7.02091 0.179086 7.37909 0.4 7.6C0.620914 7.82091 0.979086 7.82091 1.2 7.6L4 4.8L6.8 7.6C7.02091 7.82091 7.37909 7.82091 7.6 7.6C7.82091 7.37909 7.82091 7.02091 7.6 6.8L4.8 4Z"
              fill="#B3E8D4"
            />
          </svg>
        </div>
      </template>
    </div>

    <transition name="fade">
      <div v-if="scrollTags < max && isArrow" class="t-tags__arrow" @click="scrollToRight">
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.81304 5.49489L0.902746 0L0 1.01022L4.45892 6L0 10.9898L0.902746 12L5.81304 6.50511C6.06232 6.22615 6.06232 5.77385 5.81304 5.49489Z"
            fill="#929292"
          />
        </svg>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    tags: Array,
    disableFilter: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    isContainer: {
      type: Boolean,
      default: true,
    },
    isAll: {
      type: Boolean,
      default: false,
    },
    isArrow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      checked: [],
      idTags: 'tags',
      scrollTags: 0,
      max: 0,
    }
  },
  methods: {
    addTags(index, id) {
      // удаляем при повторном нажатии
      if (this.isAll && this.checked[index] === id) {
        this.checked[index] = undefined
        this.routerPush()
      } else {
        this.checked[index] = id
        this.routerPush()
      }
    },
    deleteTags(index, id) {
      if (!this.isAll || index) {
        this.checked[index] = undefined
        this.routerPush()
      } else {
        this.checked.fill(undefined)
        this.routerPush()
      }
    },
    routerPush() {
      let query = {}
      query = {
        tags: this.checked
          .filter(item => {
            return item !== undefined
          })
          .join(','),
      }
      if (!query.tags) {
        query = { tags: undefined }
      }
      // this.$root.setDataAnimateFalse();
      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign(
            {},
            this.$route.query,
            {
              loadMore: undefined,
              currentPage: undefined,
            },
            query
          ),
        })
        .catch(err => {})

      this.changeScroll()
    },
    changeScroll() {
      this.scrollTags = this.$refs.tags.scrollLeft
      this.max = this.$refs.tags.scrollWidth - this.$refs.tags.clientWidth
    },
    scrollToLeft() {
      this.$refs.tags.scrollTo({
        left: this.$refs.tags.scrollLeft - 160,
        behavior: 'smooth',
      })
    },
    scrollToRight() {
      this.$refs.tags.scrollTo({
        left: this.$refs.tags.scrollLeft + 160,
        behavior: 'smooth',
      })
    },
  },
  mounted() {
    this.max = this.$refs.tags.scrollWidth - this.$refs.tags.clientWidth
    window.addEventListener('resize', this.changeScroll)
    setTimeout(() => {
      this.tags.forEach(item => {
        if (this.$route.query[this.idTags]) {
          this.checked.push(this.$route.query[this.idTags].indexOf(item.id) > -1 ? item.id : undefined)
        }
      })
    }, 100)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.changeScroll)
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.t-tags-block
    margin: 24px 0 40px
    display: flex
    flex-wrap: wrap
    align-items: center
    &__item
        margin: 0 8px 0 0
        padding: 8px 16px
        color: $gray-text
        opacity: .7
        font-size: 13px
        line-height: 130%
        border: 1px solid $gray-text
        border-radius: 6px
        white-space: nowrap

    @media screen and (min-width: $desktop-medium)
        &__item
            font-size: 16px

    @media screen and (min-width: $desktop-big)
        &__item
            font-size: 18px

.t-tags
    position: relative

    &._white
        .t-tags__arrow
            &:after
                background: linear-gradient(270.12deg, #FFFFFF 18.24%, rgba(242, 242, 242, 0) 104.39%)
    &._views
        .t-tags__arrow
            right: -16px
            &._left
                left: -16px
                right: auto

    &__container
        display: flex
        align-items: center
        overflow-x: auto
        width: 100%
        margin: 32px auto 24px
        scrollbar-width: none
        &::-webkit-scrollbar
            display: none

    &__arrow
        position: absolute
        right: 28px
        height: 28px
        padding: 8px
        top: calc(50% - 14px)
        cursor: pointer
        z-index: 1
        svg
            display: block
            position: relative
            z-index: 2
            path
                transition: all .2s
        &:hover svg path
            fill: $cyan
        &._left
            left: 28px
            right: auto
            transform: rotate(180deg)
            -moz-transform: rotate(180deg)
            transform-style: preserve-3d
            &:after
                right: auto
                left: calc(-100% - 60px)
        &:after
            content: ''
            position: absolute
            width: 72px
            height: 40px
            top: -6px
            right: 30px
            background: linear-gradient(270.12deg, #F2F2F2 18.24%, rgba(242, 242, 242, 0) 104.39%)
            pointer-events: none

    &__item
        margin-right: 12px
        padding: 8px 16px
        border: 1px solid $gray-text
        border-radius: 6px
        color: $gray-text
        transition: all .2s
        white-space: nowrap
        cursor: pointer
        &._active
            background-color: $cyan
            border-color: $cyan
            color: #fff !important

            .t-tags__delete
                width: 12px
                height: 12px
                opacity: 1
                margin-left: 8px
        &:hover
            color: $dark-blue
        &:active
            color: $dark-blue
            transform: scale3d(0.99, 0.99, 1)

    &__delete
        width: 0
        opacity: 0
        margin: 0
        transition: all .2s
        path
            transition: all .2s
        &:hover path
            fill: $dark-blue

    @media screen and (min-width: $desktop-medium)
        &__arrow
            &:after
                height: 48px
                top: -10px
                right: 54px

    @media screen and (min-width: $desktop-big)
        &__container
            margin: 48px auto 40px


    @media screen and (max-width: $desktop-small)
        &__name
            font-size: 13px
        &__arrow
            &:after
                right: 20px
                height: 42px
                top: -7px
            &._left
                &:after
                    left: -70px

    @media screen and (max-width: $tablet-size)
        &__arrow
            &:after
                right: 0
            &._left
                &:after
                    left: -50px

    @media screen and (max-width: $mobile-size)
        &._views
            .t-tags__arrow
                right: 0
                &._left
                    left: 0
                    right: auto

        &__name
            font-size: 12px
        &__container
            margin: 24px auto 16px
        &__item
            padding: 6px 12px
        &__arrow
            right: 0
            &._left
                right: auto
                left: 0
</style>



// WEBPACK FOOTER //
// src/templates/components/ui-components/tags/tags.vue